import React from 'react';
import { Circle } from 'lucide-react';

const ChatUsersList = ({ users, onSelectUser, unreadCounts = {} }) => {
  const getUserName = (user) => {
    if (user.firstName && user.lastName) {
      return `${user.firstName} ${user.lastName}`;
    }
    return user.email || 'Nieznany użytkownik';
  };

  if (!users || users.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-4">
        <p className="text-gray-500 text-sm">Brak użytkowników</p>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto" style={{ minHeight: 0 }}>
      {users.map((user) => {
        const unreadCount = unreadCounts[user.id] || 0;
        const isOnline = user.online || false;

        return (
          <button
            key={user.id}
            onClick={() => onSelectUser(user)}
            className="w-full px-4 py-3 hover:bg-gray-50 border-b border-gray-100 flex items-center justify-between transition-colors"
          >
            <div className="flex items-center space-x-3 flex-1 min-w-0">
              <div className="relative flex-shrink-0">
                <div className="h-10 w-10 rounded-full bg-primary-600 flex items-center justify-center text-white font-medium">
                  {getUserName(user).charAt(0).toUpperCase()}
                </div>
                {isOnline && (
                  <div className="absolute bottom-0 right-0 h-3 w-3 bg-green-500 border-2 border-white rounded-full"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-gray-900 truncate">{getUserName(user)}</p>
                <p className="text-xs text-gray-500 truncate">{user.email}</p>
              </div>
            </div>
            {unreadCount > 0 && (
              <div className="ml-2 flex-shrink-0">
                <span className="bg-primary-500 text-white text-xs font-semibold rounded-full px-2 py-1 min-w-[20px] text-center">
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default ChatUsersList;
